import { render, staticRenderFns } from "./ParticipantFormTextCoupon.vue?vue&type=template&id=0200b630&scoped=true"
import script from "./ParticipantFormTextCoupon.vue?vue&type=script&lang=js"
export * from "./ParticipantFormTextCoupon.vue?vue&type=script&lang=js"
import style0 from "./ParticipantFormTextCoupon.vue?vue&type=style&index=0&id=0200b630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0200b630",
  null
  
)

export default component.exports